export const VARIANTS = {
  initial: {
    hiddenOpacity: { opacity: 0 },
    hiddenFromBottom: { y: '20px', opacity: 0 },
    hiddenFromTop: { y: '-20px', opacity: 0 },
    hiddenFromLeft: { x: '-20px', opacity: 0 },
    hiddenFromRight: { x: '20px', opacity: 0 },
  },
  animate: {
    visibleOpacity: { opacity: 1 },
    visibleXY: { y: 0, x: 0, opacity: 1 },
  },
  exit: {
    toTop: { y: '-20px', opacity: 0 },
    toBottom: { y: '20px', opacity: 0 },
    toLeft: { x: '-20px', opacity: 0 },
    toRight: { x: '20px', opacity: 0 },
    opacity: { opacity: 0, transition: { ease: 'easeIn', duration: 0.1 } },
  },
  transition: {
    default: {
      type: 'spring',
      stiffness: 260,
      damping: 28,
      ease: 'easeOut',
    },
  },
  // LIST
  LIST: {
    exit: {
      opacity: 0,
      height: 0,
      marginBottom: '0px',
      transition: { duration: 0.3 },
    },
    close: {
      height: 0,
      opacity: 0,
    },
    open: {
      height: 'auto',
      marginBottom: '2rem',
      opacity: 1,
    },
  },
};
